import { useMemo } from 'react';
import { type VariantOption } from '../../../shared/useSelectedVariants';
import { type FinanceProductFormValues } from '../../index';
import { type InsuranceFeeTableRecord } from './shared';

const useInsuranceFeeRecords = (vehicles: VariantOption[], insuranceFee?: FinanceProductFormValues['insuranceFee']) =>
    useMemo((): InsuranceFeeTableRecord[] => {
        if (!vehicles?.length) {
            return [];
        }

        return vehicles.map(({ name, id }: VariantOption) => {
            const row = insuranceFee?.table?.find(row => row.variantSuiteId === id);

            return {
                variantSuiteId: id,
                variantName: name,
                value: row?.value ?? 0,
            };
        });
    }, [insuranceFee, vehicles]);

export default useInsuranceFeeRecords;
